/* eslint-disable @angular-eslint/directive-selector */

import {
    Directive,
    AfterViewInit,
    ElementRef,
    NgZone,
    OnDestroy
} from '@angular/core';

@Directive({
    selector: 'p-dropdown, p-multiselect'
})
export class GlobalDropdownTooltipDirective implements AfterViewInit, OnDestroy {

    private observer!: MutationObserver;

    constructor(private el: ElementRef, private zone: NgZone) { }

    ngAfterViewInit(): void {
        this.zone.runOutsideAngular(() => {

            // Esperar render completo de PrimeNG
            setTimeout(() => this.applyTooltips(), 50);

            this.observer = new MutationObserver(() => {
                this.applyTooltips();
            });

            // Observamos el elemento padre real
            this.observer.observe(this.el.nativeElement.parentElement, {
                childList: true,
                subtree: true
            });
        });
    }

    ngOnDestroy(): void {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    private applyTooltips(): void {

        // Buscar contenedor real renderizado por PrimeNG
        const dropdownContainer =
            this.el.nativeElement.parentElement?.querySelector('.p-dropdown');

        const multiContainer =
            this.el.nativeElement.parentElement?.querySelector('.p-multiselect');

        // ===============================
        // DROPDOWN
        // ===============================

        if (dropdownContainer) {

            const trigger =
                dropdownContainer.querySelector('.p-dropdown-trigger');

            this.setTitle(trigger, 'Mostrar opciones');

            const clearIcon =
                dropdownContainer.querySelector('.p-dropdown-clear-icon');

            if (clearIcon) {
                this.setTitle(dropdownContainer, 'Limpiar selección');
            }
        }

        // ===============================
        // MULTISELECT
        // ===============================

        if (multiContainer) {

            const trigger =
                multiContainer.querySelector('.p-multiselect-trigger');

            this.setTitle(trigger, 'Mostrar opciones');

            const clearIcon =
                multiContainer.querySelector('.p-multiselect-clear-icon');

            if (clearIcon) {
                this.setTitle(multiContainer, 'Limpiar selección');
            }
        }
    }

    private setTitle(element: Element | null, text: string): void {
        if (!element) {
            return;
        }

        if (!element.getAttribute('title')) {
            element.setAttribute('title', text);
        }
    }


}
